import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import loadingGif from "../../images/loading.gif"
import queryString from "query-string"
import {
  deliberationsContainer,
  deliberationsYearWrapper,
  deliberationsMonthList,
  deliberationsDocumentList,
  deliberationsLoadingWrapper,
  deliberationsLoadingSpinner,
  tabHidden,
} from "./deliberations.module.scss"
import { MonthFilter, YearFilter } from "./deliberations-styled.js"

const Deliberations = ({ deliberationsData }) => {
  const [filteredDeliberationsData, setFilteredDeliberationsData] = useState({})
  const [classifications, setClassifications] = useState([])
  const [classificationFilter, setClassificationFilter] = useState(null)
  const [
    deliberationsDataPerClassification,
    setDeliberationsDataPerClassification,
  ] = useState({})
  const [selectedAnnee, setSelectedAnnee] = useState(null)
  const [selectedMonth, setSelectedMonth] = useState(null)

  useEffect(() => {
    const params = queryString.parse(location.search)
    setClassificationFilter(params?.filter)
    const deliberationsDataPerClassificationArray = []
    const classificationsArray = []
    Object.keys(deliberationsData).map((annee) => {
      Object.keys(deliberationsData[annee]).map((mois) => {
        Object.keys(deliberationsData[annee][mois]).map((dateImport) => {
          Object.keys(deliberationsData[annee][mois][dateImport]).map(
            (dateDocument) => {
              Object.keys(
                deliberationsData[annee][mois][dateImport][dateDocument]
              ).map((document) => {
                const deliberation =
                  deliberationsData[annee][mois][dateImport][dateDocument][
                    document
                  ]
                const classification = deliberation.classification
                if (classification === null) return
                if (classificationsArray.includes(classification) === false) {
                  classificationsArray.push(classification)
                }
                const classificationCode = classification.split(" - ")[0]
                deliberationsDataPerClassificationArray[classificationCode] ??=
                  {}
                deliberationsDataPerClassificationArray[classificationCode][
                  annee
                ] ??= {}
                deliberationsDataPerClassificationArray[classificationCode][
                  annee
                ][mois] ??= {}
                deliberationsDataPerClassificationArray[classificationCode][
                  annee
                ][mois][dateImport] ??= {}
                deliberationsDataPerClassificationArray[classificationCode][
                  annee
                ][mois][dateImport][dateDocument] ??= []
                deliberationsDataPerClassificationArray[classificationCode][
                  annee
                ][mois][dateImport][dateDocument].push(deliberation)
              })
            }
          )
        })
      })
    })
    classificationsArray.sort()
    setClassifications(classificationsArray)
    setDeliberationsDataPerClassification(
      deliberationsDataPerClassificationArray
    )
    setFilteredDeliberationsData(deliberationsData)
  }, [deliberationsData])

  useEffect(() => {
    setSelectedAnnee(null)
    setSelectedMonth(null)
    if (Object.keys(filteredDeliberationsData).length === 1) {
      const newAnnee = Object.keys(filteredDeliberationsData)[0]
      setSelectedAnnee(newAnnee)
      if (Object.keys(filteredDeliberationsData[newAnnee]).length === 1) {
        const newMonth = Object.keys(filteredDeliberationsData[newAnnee])[0]
        setSelectedMonth(newMonth)
      }
    }
  }, [filteredDeliberationsData])

  useEffect(() => {
    if (filteredDeliberationsData && selectedAnnee) {
      setSelectedMonth(
        Object.keys(filteredDeliberationsData[selectedAnnee])
          .sort()
          .reverse()[0]
      )
    }
  }, [selectedAnnee])

  useEffect(() => {
    if (classificationFilter) {
      setFilteredDeliberationsData(
        deliberationsDataPerClassification[classificationFilter]
      )
    }
  }, [classificationFilter])

  const changeClassification = (event) => {
    const classification = event.target.value
    if (classification === "all") {
      setFilteredDeliberationsData(deliberationsData)
    } else {
      const classificationCode = classification.split(" - ")[0]
      setFilteredDeliberationsData(
        deliberationsDataPerClassification[classificationCode]
      )
    }
  }

  return (
    <div>
      <div>
        {!deliberationsData && (
          <div className={deliberationsLoadingWrapper}>
            <img
              alt="loading gif"
              src={loadingGif}
              className={deliberationsLoadingSpinner}
            />
            <span>Chargement des données...</span>
          </div>
        )}
        {deliberationsData &&
          (!Object.keys(deliberationsData).length ? (
            <span>Aucun acte présent</span>
          ) : (
            <>
              <div
                className={deliberationsYearWrapper}
                role={"tablist"}
                aria-label={"Liste des années"}
              >
                {Object.keys(filteredDeliberationsData).map((annee, index) => (
                  <YearFilter
                    key={index}
                    onClick={() => {
                      setSelectedAnnee(annee)
                    }}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        setSelectedAnnee(annee)
                      }
                    }}
                    active={annee === selectedAnnee}
                    className="btn"
                    id={"tab-" + annee}
                    role={"tab"}
                    aria-selected={annee === selectedAnnee}
                    aria-controls={"tabpanel-" + annee}
                    tabIndex={0}
                  >
                    {parseInt(annee)}
                  </YearFilter>
                ))}
                {classifications && !classificationFilter && (
                  <div>
                    <select onChange={changeClassification}>
                      <option value="all">Toutes les classifications</option>
                      {classifications.map((classification, index) => (
                        <>
                          <option value={classification}>
                            {classification}
                          </option>
                        </>
                      ))}
                    </select>
                  </div>
                )}
              </div>

              {!selectedAnnee ? (
                <p>Veuillez sélectionner une année</p>
              ) : (
                !selectedMonth && <p>Veuillez sélectionner un mois</p>
              )}

              {Object.keys(filteredDeliberationsData).map((annee, index) => {
                const classesYears = `${deliberationsContainer} ${
                  selectedAnnee !== annee ? tabHidden : ""
                }`
                return (
                  <div
                    key={index}
                    className={classesYears}
                    role="tabpanel"
                    id={"tabpanel-" + annee}
                    aria-labelledby={"tab-" + annee}
                  >
                    {filteredDeliberationsData[annee] && (
                      <>
                        <div
                          className={deliberationsMonthList}
                          role={"tablist"}
                          aria-label={"Liste des mois"}
                        >
                          {Object.keys(filteredDeliberationsData[annee])
                            .sort((monthA, monthB) => monthB - monthA)
                            .map((mois, indexMois) => {
                              const date = new Date()
                              date.setMonth(mois - 1)
                              const labelMois = date.toLocaleString("fr-FR", {
                                month: "long",
                              })
                              return (
                                <MonthFilter
                                  key={indexMois}
                                  onClick={() => setSelectedMonth(mois)}
                                  active={mois === selectedMonth}
                                  id={"tab-" + mois}
                                  role="tab"
                                  aria-selected={mois === selectedMonth}
                                  aria-controls={"tabpanel-" + mois}
                                  onKeyDown={(event) => {
                                    if (event.key === "Enter") {
                                      setSelectedMonth(mois)
                                    }
                                  }}
                                  tabIndex={0}
                                >
                                  {labelMois}
                                </MonthFilter>
                              )
                            })}
                        </div>
                        {Object.keys(filteredDeliberationsData[annee]).map(
                          (month, indexContent) => {
                            const classesMonths = `${deliberationsDocumentList} ${
                              month !== selectedMonth ? tabHidden : ""
                            }`
                            return (
                              <div
                                key={indexContent}
                                className={classesMonths}
                                role="tabpanel"
                                id={"tabpanel-" + month}
                                aria-labelledby={"tab-" + month}
                              >
                                <table>
                                  {selectedMonth && (
                                    <tr>
                                      <th>Document</th>
                                      <th>Date de publication</th>
                                      <th>Classification</th>
                                    </tr>
                                  )}
                                  {Object.keys(
                                    filteredDeliberationsData[annee]
                                  ).map(
                                    (mois, indexMois) =>
                                      selectedMonth === mois &&
                                      Object.keys(
                                        filteredDeliberationsData[annee][mois]
                                      )
                                        .sort((dayA, dayB) => dayB - dayA)
                                        .map((jourImport) =>
                                          Object.keys(
                                            filteredDeliberationsData[annee][
                                              mois
                                            ][jourImport]
                                          ).map(
                                            (jourDocument, indexJourDocument) =>
                                              filteredDeliberationsData[annee][
                                                mois
                                              ][jourImport][jourDocument].map(
                                                (document, indexDocument) => {
                                                  const dateImport =
                                                    document.dateImport &&
                                                    document.dateImport !== "--"
                                                      ? new Date(
                                                          document.dateImport
                                                        )
                                                      : new Date(
                                                          document.dateDocument
                                                        )

                                                  const name =
                                                    document.name ??
                                                    document.path
                                                      .split("/")
                                                      .pop()

                                                  return (
                                                    <tr key={indexJourDocument}>
                                                      <td>
                                                        <a
                                                          href={
                                                            process.env
                                                              .GATSBYSIDE_DRUPAL_URL +
                                                            document.path
                                                          }
                                                          target="_blank"
                                                          rel="noreferrer"
                                                        >
                                                          {name}
                                                        </a>
                                                      </td>
                                                      <td>
                                                        {dateImport.toString() !==
                                                        "Invalid Date"
                                                          ? dateImport.toLocaleString(
                                                              "fr-FR",
                                                              {
                                                                year: "numeric",
                                                                month: "long",
                                                                day: "numeric",
                                                              }
                                                            )
                                                          : "Pas de date"}
                                                      </td>
                                                      <td>
                                                        {
                                                          document.classification
                                                        }
                                                      </td>
                                                    </tr>
                                                  )
                                                }
                                              )
                                          )
                                        )
                                  )}
                                </table>
                              </div>
                            )
                          }
                        )}
                      </>
                    )}
                  </div>
                )
              })}
            </>
          ))}
      </div>
    </div>
  )
}

Deliberations.propTypes = {
  deliberationsData: PropTypes.object,
}

export default Deliberations
